'use strict';

exports = module.exports = require('./lib/memoizer')['default'];
exports['default'] = exports;



//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/intl-format-cache/index.js
// module id = 205
// module chunks = 0 1 2 4 5 6